class CartPageRecommendations {
  constructor() {
    this.currentRequest = null;
    this.init();
  }

  init() {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => this.setupEventListeners());
    } else {
      this.setupEventListeners();
    }
  }

  setupEventListeners() {
    if (document.body.classList.contains('page-cart')) {
      setTimeout(() => {
        this.loadRecommendationsForLastCartItem();
      }, 500);
    }

    document.addEventListener('cart:updated', (event) => {
      if (document.body.classList.contains('page-cart')) {
        setTimeout(() => {
          this.loadRecommendationsForLastCartItem();
        }, 200);
      }
    });
  }

  loadRecommendationsForLastCartItem() {
    const recommendationsContainer = document.getElementById('cart-page-recommendations');
    if (!recommendationsContainer) return;

    const cartItems = document.querySelectorAll('.cart-item');
    if (cartItems.length === 0) {
      this.hideRecommendations();
      return;
    }

    const lastCartItem = cartItems[cartItems.length - 1];
    const productLink = lastCartItem.querySelector('a[href*="/products/"]');
    if (!productLink) {
      this.hideRecommendations();
      return;
    }

    const productHandle = this.extractProductHandle(productLink.href);
    productHandle ? this.loadRecommendations(productHandle) : this.hideRecommendations();
  }

  extractProductHandle(productUrl) {
    try {
      const handle = productUrl.split('/products/')[1];
      return handle ? handle.split('?')[0].split('&')[0] : null;
    } catch (error) {
      console.error('Error extracting product handle:', error);
      return null;
    }
  }

  async loadRecommendations(productHandle) {
    const recommendationsContainer = document.getElementById('cart-page-recommendations');
    const recommendationsGrid = document.getElementById('cart-page-recommendations-grid');
    
    if (!recommendationsContainer || !recommendationsGrid) return;

    if (this.currentRequest === productHandle) return;
    
    this.currentRequest = productHandle;
    this.showLoadingState();

    try {
      const productResponse = await fetch(`/products/${productHandle}.js`);
      if (!productResponse.ok) throw new Error(`HTTP error! status: ${productResponse.status}`);
      
      const product = await productResponse.json();
      
      const recommendationsResponse = await fetch(
        `${window.location.origin}/recommendations/products?product_id=${product.id}&limit=5&section_id=cart-page-recommendations`
      );
      
      if (!recommendationsResponse.ok) throw new Error(`HTTP error! status: ${recommendationsResponse.status}`);
      
      const text = await recommendationsResponse.text();
      const html = document.createElement('div');
      html.innerHTML = text;
      const recommendations = html.querySelector('.cart-page__recommendations');

      if (recommendations && recommendations.innerHTML.trim().length > 0) {
        this.renderRecommendations(recommendations);
      } else {
        this.showEmptyState();
      }
    } catch (error) {
      console.error('Error loading cart page recommendations:', error);
      this.showErrorState();
    } finally {
      this.currentRequest = null;
    }
  }

  showLoadingState() {
    const container = document.getElementById('cart-page-recommendations');
    const grid = document.getElementById('cart-page-recommendations-grid');
    if (!container || !grid) return;

    container.style.display = 'block';
    grid.innerHTML = '<div class="cart-recommendations-loading"><div class="loading__spinner"></div></div>';
  }

  showEmptyState() {
    const container = document.getElementById('cart-page-recommendations');
    if (container) container.style.display = 'none';
  }

  showErrorState() {
    const container = document.getElementById('cart-page-recommendations');
    if (container) container.style.display = 'none';
  }

  hideRecommendations() {
    const container = document.getElementById('cart-page-recommendations');
    if (container) container.style.display = 'none';
  }

  renderRecommendations(recommendationsElement) {
    const container = document.getElementById('cart-page-recommendations');
    const grid = document.getElementById('cart-page-recommendations-grid');
    if (!container || !grid) return;

    const recommendationsGrid = recommendationsElement.querySelector('.cart-page__recommendations-grid');
    if (!recommendationsGrid) return;

    grid.innerHTML = '';
    const clonedContent = recommendationsGrid.cloneNode(true);
    grid.appendChild(clonedContent);
    container.style.display = 'block';
  }
}

const cartPageRecommendations = new CartPageRecommendations();
window.CartPageRecommendations = cartPageRecommendations;
